<template>
  <div class="error-alert-dialog-container" v-if="showErrorAlertDialog">
    <wxc-overlay :left="left" :show="true" :hasAnimation="false"></wxc-overlay>
    <div class="dialog-box" :style="{top:top+'px', left: left + 'px', right: right + 'px'}">
      <div class="dialog-content-without-cross">
        <weex-text
            v-if="getTitle"
            class="font-size-base"
            v-html="getTitle"
        ></weex-text>

        <weex-text
            v-if="getDescription"
            class="font-size-sm margin-top-5"
            v-html="getDescription"
        ></weex-text>

        <div class="item-row-alignment margin_top_40">
          <wxc-button
            text="Contact Support"
            size="small"
            type="green"
            class="horizontal_center"
            @wxcButtonClicked="onContactSupportClicked"
          ></wxc-button>

          <wxc-button
            text="Dismiss"
            size="small"
            type="red"
            class="horizontal_center"
            @wxcButtonClicked="onDismissClicked"
          ></wxc-button>
        </div>


      </div>
    </div>
  </div>
</template>

<script>
import WxcButton from "../../../weex-ui/packages/wxc-button/index";
import WxcOverlay from "../../../weex-ui/packages/wxc-overlay/index";

export default {
  components: { WxcOverlay, WxcButton },
  props: {
    showErrorAlertDialog: {
      type: Boolean,
      default: false
    },

    error: {
      type: Object,
      default: () => ({})
    },

    top: {
      type: Number,
      default: 200
    },

    left: {
      type: Number,
      default: 0
    },

    right: {
      type: Number,
      default: 0
    },

    bottom: {
      type: Number,
      default: 50
    }
  },
  data: () => ({}),

  methods: {
    onContactSupportClicked() {
      this.$emit("contactSupport", { title: this.getTitle, description: this.getDescription });
    },

    onDismissClicked() {
      this.$emit("dismissClicked", {});
    }
  },

  computed: {
    getTitle() {
      return this.error && this.error.title ? this.error.title : "";
    },

    getDescription() {
      return this.error && this.error.description ? this.error.description : "";
    }
  }
};
</script>


<style
  scoped
  src="../../assets/style/base.css"></style>

<style scoped>
.error-alert-dialog-container {
  position: fixed;
  z-index: 99999;
}
</style>
